import { simplApi } from '../api/simplApi';
import bowser from 'bowser';

export const logActivity = (
  category = null,
  action = null,
  data_id = null,
  additional_data = {},
) => {
  const browserDetection = bowser
    .getParser(window.navigator.userAgent)
    .getBrowser();
  let browser = null;

  if (
    typeof browserDetection.name !== 'undefined' &&
    browserDetection.name.length
  ) {
    browser = browserDetection.name;
  }

  const data = {
    method: 'post',
    body: {
      events: [
        {
          category,
          action,
          data_id,
          additional_data: {
            ...additional_data,
            browserDetection,
          },
          browser,
          browser_width: window.innerWidth,
        },
      ],
    },
  };

  simplApi('keepalive', data);
};

export default logActivity;



// WEBPACK FOOTER //
// ./src/helpers/logActivity.js